import { render, staticRenderFns } from "./ImageDisplay.vue?vue&type=template&id=361a3fc8&scoped=true"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361a3fc8",
  null
  
)

export default component.exports